import { Link } from 'react-router-dom';

export default function AboutPage() {
  const scrollToContact = () => {
    window.REACT_APP_NAVIGATE('/');
    setTimeout(() => {
      const element = document.getElementById('contact');
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }, 100);
  };

  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="fixed top-0 left-0 right-0 bg-white/95 backdrop-blur-sm z-50 border-b border-gray-200">
        <nav className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="flex items-center justify-between h-20">
            <h1>
              <Link to="/" className="flex items-center gap-3 hover:opacity-70 transition-opacity cursor-pointer">
                <img 
                  src="https://static.readdy.ai/image/dc94b4331bde31366815bfe78425789e/ee77cd5e24359f194577e6ccca300426.png" 
                  alt="Nowest ロゴ" 
                  className="h-10 w-auto object-contain"
                />
                <span className="text-2xl font-semibold text-primary">Nowest</span>
              </Link>
            </h1>
            <div className="hidden md:flex items-center space-x-10">
              <Link to="/" className="text-secondary hover:text-primary transition-colors font-medium cursor-pointer">
                トップ
              </Link>
              <Link to="/features" className="text-secondary hover:text-primary transition-colors font-medium cursor-pointer">
                特徴
              </Link>
              <Link to="/about" className="text-primary font-medium cursor-pointer">
                会社概要
              </Link>
              <button onClick={scrollToContact} className="bg-primary text-white px-6 py-2.5 hover:bg-accent transition-colors font-medium whitespace-nowrap cursor-pointer">
                お問い合わせ
              </button>
            </div>
          </div>
        </nav>
      </header>

      {/* Hero */}
      <section className="pt-32 pb-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="flex items-center gap-2 text-sm text-secondary mb-8">
            <Link to="/" className="hover:text-primary transition-colors cursor-pointer">Top</Link>
            <span>/</span>
            <span className="text-primary">会社概要</span>
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold text-primary mb-6">会社概要</h2>
          <p className="text-xl text-secondary max-w-3xl">
            「覚えられない」を無くす。私たちのビジョンと会社情報をご紹介します。
          </p>
        </div>
      </section>

      {/* Vision Section */}
      <section className="py-24 border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-16 items-center">
            <div>
              <p className="text-sm text-secondary mb-4 tracking-widest">VISION</p>
              <h3 className="text-3xl lg:text-4xl font-bold text-primary mb-8 leading-tight">
                覚えられないを無くす
              </h3>
              <p className="text-lg text-secondary leading-relaxed mb-6">
                覚える事が苦手なお子さんや親御さんのパートナーとして、私たちは、独自の記憶メソッドとAIテクノロジーを通じて誠実な価値を提供します。
              </p>
              <p className="text-lg text-secondary leading-relaxed">
                小さな成功体験の積み重ねにより自己効力感や自己肯定感を高め、より自分らしく生き生きとした人生を送ることができる。そんな長期的なベネフィットを目指しています。
              </p>
            </div>
            <div className="relative">
              <img
                src="https://static.readdy.ai/image/dc94b4331bde31366815bfe78425789e/fc97ccb351790e08d6e9e9fc46378489.jpeg"
                alt="Nowest オフィス"
                className="w-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Founder Section */}
      <section className="py-24 bg-gray-50">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="text-center mb-16">
            <p className="text-sm text-secondary mb-4 tracking-widest">FOUNDER</p>
            <h3 className="text-4xl font-bold text-primary mb-4">代表者紹介</h3>
          </div>
          
          <div className="max-w-5xl mx-auto bg-white p-10 lg:p-16">
            <div className="mb-10 text-center">
              <h4 className="text-3xl font-bold text-primary mb-2">今西 良光（きおクマ）</h4>
              <p className="text-secondary mb-4 text-lg">代表取締役</p>
            </div>
            
            <div className="space-y-8">
              <div>
                <h5 className="font-bold text-primary mb-3 flex items-center gap-2 text-xl">
                  <i className="ri-trophy-line text-xl"></i>
                  ギネスワールドレコーズ認定
                </h5>
                <p className="text-secondary leading-relaxed">
                  オセロ記憶の世界記録保持者として、ギネスワールドレコーズに認定されています。この実績を基に、誰もが再現できる体系的な記憶メソッドを開発しました。（取得レコード名「The most Othello (reversi) boards memorised」）
                </p>
              </div>

              <div>
                <h5 className="font-bold text-primary mb-3 flex items-center gap-2 text-xl">
                  <i className="ri-lightbulb-line text-xl"></i>
                  独自の記憶メソッド
                </h5>
                <p className="text-secondary leading-relaxed">
                  長年の研究と実践により確立した独自の記憶メソッドは、再現性が高く、様々な内容を効果的に覚えることができます。このメソッドをオンラインスクールや企業向け研修で提供しています。
                </p>
              </div>

              <div>
                <h5 className="font-bold text-primary mb-3 flex items-center gap-2 text-xl">
                  <i className="ri-robot-line text-xl"></i>
                  AIチューターの開発
                </h5>
                <p className="text-secondary leading-relaxed">
                  体系化された記憶メソッドを独自に学習させたAIチューターを開発。イメージがしにくい方、記憶が苦手な方、読み書きに障害がある方、ADHD・ASDなどの発達特性をお持ちのお子さんでも、とても学びやすく「覚えられた」という小さな成功体験を積むことができます。
                </p>
              </div>

              <div>
                <h5 className="font-bold text-primary mb-3 flex items-center gap-2 text-xl">
                  <i className="ri-heart-line text-xl"></i>
                  ミッション
                </h5>
                <p className="text-secondary leading-relaxed">
                  成功体験の積み重ねにより自己効力感や自己肯定感を高め、より自分らしく生き生きとした人生を送れるようサポートします。また、イメージ力を鍛えることで、目標達成や感情のセルフコントロールもサポートしています。
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Company Info */}
      <section className="py-24">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <h3 className="text-3xl font-bold text-primary mb-12">基本情報</h3>
          <div className="border-t border-gray-200">
            <div className="grid md:grid-cols-4 py-6 border-b border-gray-200">
              <div className="text-secondary font-medium mb-2 md:mb-0">会社名</div>
              <div className="md:col-span-3 text-primary">株式会社 Nowest</div>
            </div>
            <div className="grid md:grid-cols-4 py-6 border-b border-gray-200">
              <div className="text-secondary font-medium mb-2 md:mb-0">設立</div>
              <div className="md:col-span-3 text-primary">2019年5月</div>
            </div>
            <div className="grid md:grid-cols-4 py-6 border-b border-gray-200">
              <div className="text-secondary font-medium mb-2 md:mb-0">所在地</div>
              <div className="md:col-span-3 text-primary">東京都新宿区西新宿一丁目26番2号新宿野村ビル32階</div>
            </div>
            <div className="grid md:grid-cols-4 py-6 border-b border-gray-200">
              <div className="text-secondary font-medium mb-2 md:mb-0">代表者</div>
              <div className="md:col-span-3 text-primary">代表取締役　今西 良光</div>
            </div>
            <div className="grid md:grid-cols-4 py-6 border-b border-gray-200">
              <div className="text-secondary font-medium mb-2 md:mb-0">事業内容</div>
              <div className="md:col-span-3 text-primary">
                <ul className="space-y-2">
                  <li>・記憶のオンラインスクール「KIOQ」運営</li>
                  <li>・独自記憶メソッドの研究開発</li>
                  <li>・AIチューターの開発・提供</li>
                  <li>・法人向け研修</li>
                  <li>・学習塾・教育機関向けコンサルティング</li>
                  <li>・特別支援教育向けコンテンツ制作</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-24">
        <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center">
          <h3 className="text-3xl font-bold text-primary mb-6">
            お問い合わせ
          </h3>
          <p className="text-lg text-secondary mb-10">
            サービスに関するご質問やご相談は、お気軽にお問い合わせください。
          </p>
          <button
            onClick={scrollToContact}
            className="inline-block bg-primary text-white px-10 py-4 hover:bg-accent transition-colors font-semibold whitespace-nowrap cursor-pointer"
          >
            お問い合わせはこちら
          </button>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-primary text-gray-300">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
          <div className="grid md:grid-cols-4 gap-12 mb-12">
            <div className="md:col-span-2">
              <h4 className="text-2xl font-semibold text-white mb-4">Nowest</h4>
              <p className="text-gray-400 mb-6 leading-relaxed">
                「覚えられない」を無くす。ギネス世界記録保持者が開発した独自の記憶メソッドとAIで、すべての人に学びの成功体験を提供します。
              </p>
            </div>
            <div>
              <h5 className="text-white font-semibold mb-4">サービス</h5>
              <ul className="space-y-3">
                <li><Link to="/#services" className="hover:text-white transition-colors cursor-pointer">オンラインスクール</Link></li>
                <li><Link to="/#services" className="hover:text-white transition-colors cursor-pointer">法人向け研修</Link></li>
                <li><Link to="/#services" className="hover:text-white transition-colors cursor-pointer">コンテンツ制作</Link></li>
              </ul>
            </div>
            <div>
              <h5 className="text-white font-semibold mb-4">会社情報</h5>
              <ul className="space-y-3">
                <li><Link to="/about" className="hover:text-white transition-colors cursor-pointer">会社概要</Link></li>
                <li><Link to="/features" className="hover:text-white transition-colors cursor-pointer">特徴</Link></li>
                <li><Link to="/legal" className="hover:text-white transition-colors cursor-pointer">特定商取引法</Link></li>
                <li><button onClick={scrollToContact} className="hover:text-white transition-colors cursor-pointer text-left">お問い合わせ</button></li>
              </ul>
            </div>
          </div>
          <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-500 text-sm">© 2025 Nowest,inc. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
}
